import { createPortal } from 'react-dom';
import { useGetGmtOffset } from '../hooks';
import { useTimezoneTooltip } from './hooks';
import styles from './timezones-with-tooltip.module.css';

type Properties = {
  gmtOffsetReferenceDate: Date;
  orderedTimezones: string[];
};

const TimezonesWithTooltip = ({ gmtOffsetReferenceDate, orderedTimezones }: Properties) => {
  const getGmtOffset = useGetGmtOffset();
  const { hideTooltip, showTooltip, tooltip } = useTimezoneTooltip();

  return (
    <>
      {orderedTimezones.map((timeZone) => (
        <div
          className={styles.timezone}
          key={timeZone}
          onMouseEnter={(event) => {
            showTooltip(event, timeZone);
          }}
          onMouseLeave={hideTooltip}
        >
          <span className={styles['timezone-label']}>
            ({getGmtOffset({ referenceDate: gmtOffsetReferenceDate, timeZone })})
          </span>
        </div>
      ))}
      {tooltip
        ? createPortal(
            <span
              className={styles['tooltip-portal']}
              role="tooltip"
              style={{ left: `${tooltip.left}px`, top: `${tooltip.top}px` }}
            >
              {tooltip.text}
            </span>,
            document.body,
          )
        : null}
    </>
  );
};

export default TimezonesWithTooltip;
